import React from 'react';
import { ExternalContentWrapper } from '@/components/external-content/external-content-wrapper';
import { getDisplayedNameText } from '@/utils/string';
import { PageContainer } from '@/components/page-container';
import { useExternalContent } from '@/contexts/external-content-context';
import { useLayoutContext } from '@/contexts/layout-context';

export const ExternalContentScreen: React.FC = () => {
  const { selectedExternalContent } = useExternalContent();
  const { isSmallLayout } = useLayoutContext();
  return isSmallLayout ? (
    <PageContainer
      animateNavigationHeader={false}
      navigationHeaderProps={{
        centerTitle: true,
        showBackButton: true,
        title: getDisplayedNameText(
          selectedExternalContent?.display_name,
          selectedExternalContent?.name,
        ),
      }}
    >
      <ExternalContentWrapper />
    </PageContainer>
  ) : (
    <ExternalContentWrapper />
  );
};
